import { api } from "@/lib/api";

export const ExamSessionsAPI = {
  list: (params = {}) => api.get(`/exam-sessions`, { params }).then((r) => r.data),
  create: (payload) => api.post(`/exam-sessions`, payload).then((r) => r.data),
  get: (id) => api.get(`/exam-sessions/${id}`).then((r) => r.data),
  update: (id, patch) => api.patch(`/exam-sessions/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/exam-sessions/${id}`),

  registerStudents: (id, body) => api.post(`/exam-sessions/${id}/register-students`, body).then((r) => r.data),
  allocateRooms: (id, body = {}) => api.post(`/exam-sessions/${id}/allocate-rooms`, body).then((r) => r.data),
  assignSeats: (id, body = {}) => api.post(`/exam-sessions/${id}/assign-seats`, body).then((r) => r.data),
  seatingChart: (id) => api.get(`/exam-sessions/${id}/seating-chart`).then((r) => r.data),
  hallTicketsUrl: (id) => `${api.defaults.baseURL}/exam-sessions/${id}/hall-tickets.csv`,
};

export const EXAM_STATUSES = [
  { key: "draft",       label: "Draft",       tone: "slate"    },
  { key: "scheduled",   label: "Scheduled",   tone: "sky"      },
  { key: "in_progress", label: "In Progress", tone: "amber"    },
  { key: "completed",   label: "Completed",   tone: "emerald"  },
  { key: "cancelled",   label: "Cancelled",   tone: "rose"     },
];
